// UmfrageCard — interne Patienten-Umfrage: Link/QR für den Empfang und
// Versand per E-Mail. Antworten landen als interne Bewertungen (anonym),
// optional mit Behandler-Zuordnung über den Link-Token.
import { useState } from "react";
import { Card, CardHead, Btn, Select, Insight, toast } from "./ui";
import { getPraxis, getBehandler } from "./lib/settingsStore";
import { supabaseUrl } from "./lib/supabase";
import { serverActive } from "./lib/mode";
import { sendMails, findPatientEmail, praxisAbsender } from "./lib/mailer";
import PatientPicker from "./PatientPicker";

const buildToken = (behandlerName) => {
  const payload = { p: getPraxis().name || "", ...(behandlerName ? { b: behandlerName } : {}) };
  try { return btoa(unescape(encodeURIComponent(JSON.stringify(payload)))); } catch { return ""; }
};
export const umfrageUrl = (behandlerName) =>
  supabaseUrl ? `${supabaseUrl}/functions/v1/umfrage?t=${buildToken(behandlerName)}` : "";

export default function UmfrageCard() {
  const [beh, setBeh] = useState("");
  const [mailPat, setMailPat] = useState("");
  const url = umfrageUrl(beh);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast("Link kopiert"); }
    catch { toast("Kopieren fehlgeschlagen — Link manuell markieren.", "r"); }
  };

  const sendSurveyMail = async () => {
    if (!mailPat) { toast("Zuerst Patient wählen.", "r"); return; }
    const email = findPatientEmail(mailPat);
    if (serverActive() && !email) { toast(`Für ${mailPat} ist keine E-Mail hinterlegt.`, "r"); return; }
    try {
      const res = await sendMails([{
        to: email || "demo@dida.local", toName: mailPat,
        subject: "Wie war Ihr Besuch bei uns? — 1 Minute Feedback",
        text: `Liebe/r ${mailPat.split(",")[1]?.trim() || mailPat},\n\nvielen Dank für Ihren Besuch! Uns interessiert, wie zufrieden Sie waren — die Beantwortung dauert unter einer Minute und ist anonym:\n\n${url}\n\nHerzlichen Dank!\n\nMit freundlichen Grüßen\n${praxisAbsender()}`,
      }]);
      toast(res.simulated ? "Demo — Versand simuliert" : "Umfrage-Mail gesendet ✓");
      setMailPat("");
    } catch (e) { toast(`Versand fehlgeschlagen: ${e.message}`, "r"); }
  };

  if (!supabaseUrl) return (
    <Card><CardHead title="Interne Umfrage" icon="ti-clipboard-heart"/>
      <Insight tone="a">Die Patienten-Umfrage braucht den Live-Modus (Supabase) — im Demo-Modus nicht verfügbar.</Insight>
    </Card>
  );

  return (
    <Card>
      <CardHead title="Interne Umfrage" icon="ti-clipboard-heart"/>
      <div style={{fontSize:11,color:"var(--mf-muted)",marginBottom:10,lineHeight:1.5}}>
        Anonyme 1-Minuten-Umfrage (Gesamtzufriedenheit, Weiterempfehlung, Freitext). Antworten erscheinen automatisch unter den Bewertungen — mit Behandler-Zuordnung, wenn unten ein Behandler gewählt ist.
      </div>
      <Select label="Zuordnung" value={beh} onChange={setBeh}
        options={[{value:"",label:"Ganze Praxis (ohne Behandler)"},...getBehandler().map(b=>({value:b.name,label:b.name}))]}/>
      <div>
        <div style={{fontSize:10,color:"var(--mf-muted)",marginBottom:4}}>Link — zum Einbauen in Terminbestätigungen, Rechnungs-Mails oder die Praxis-Website</div>
        <div style={{fontSize:10.5,fontFamily:"ui-monospace,monospace",background:"var(--mf-bg-alt)",borderRadius:10,padding:"8px 10px",wordBreak:"break-all",color:"var(--mf-text)"}}>{url}</div>
        <div style={{display:"flex",gap:6,marginTop:8}}>
          <Btn color="g" onClick={copy}>Link kopieren</Btn>
          <Btn onClick={()=>window.open(url,"_blank")}>Vorschau öffnen</Btn>
        </div>
      </div>
      <div style={{borderTop:"0.5px solid var(--mf-border)",marginTop:12,paddingTop:10}}>
        <div style={{fontSize:10,color:"var(--mf-muted)",marginBottom:6}}>Oder direkt per E-Mail an einen Patienten senden:</div>
        <div style={{display:"flex",gap:8,alignItems:"flex-start",flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:200}}><PatientPicker label="Patient" value={mailPat} onChange={setMailPat}/></div>
          <Btn color="g" lg onClick={sendSurveyMail}>Umfrage-Mail senden</Btn>
        </div>
      </div>
    </Card>
  );
}
